'use client';

import { IconRegistry, type IconRegistryMap } from '@highereducation/hen-ui';

/**
 * Client boundary for request-time pack inject. Missing/empty map = no wrap,
 * so Icon stays Lucide-only (same as today).
 */
export function IconRegistryHost({
  value,
  children,
}: {
  value: IconRegistryMap | null;
  children: React.ReactNode;
}): React.ReactElement {
  if (!value) {
    return <>{children}</>;
  }

  return <IconRegistry value={value}>{children}</IconRegistry>;
}
